import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import RackNav from '@/components/rack/RackNav';
import MorphHero from '@/components/rack/MorphHero';
import ChannelSection from '@/components/rack/ChannelSection';
import AboutSection from '@/components/rack/AboutSection';
import CollabSection from '@/components/rack/CollabSection';
import ContactSection from '@/components/rack/ContactSection';
import RackFooter from '@/components/rack/RackFooter';
import { channels } from '@/data/channels';

/**
 * 首页 —— 一台机架。
 *
 * 首屏是论点（阳仔AI，对结果负责），三个通道是论据（每个方向一台在真的算东西的
 * 仪器 + 一张能力数据表 + 一个通往案例页的入口），关于解释为什么阳仔AI能开三条线，
 * 合作方式把流程和边界摊开，联系收口。整页只有首屏那一处大动作。
 */
export default function Home() {
  // 带 hash 直接进站时补一次滚动：浏览器在解析阶段就尝试跳转，那时 React 还没
  // 渲染出目标节点（main.tsx 还在等 i18n 初始化），跳转会静默落空。
  useEffect(() => {
    const id = decodeURIComponent(window.location.hash.slice(1));
    if (!id) return;
    const el = document.getElementById(id);
    if (!el) return;
    const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
    requestAnimationFrame(() =>
      el.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' }),
    );
  }, []);

  return (
    <div className="min-h-screen bg-rack-ground font-hei text-rack-bone antialiased">
      <Helmet>
        <title>阳仔AI · 独立开发者｜视觉动捕 / 智能体 / 量化</title>
        <meta
          name="description"
          content="阳仔AI（minddock.ai）· 独立开发者，为客户交付视觉动捕、智能体与量化系统。需求、方案、实现、上线、运维全链路阳仔AI负责到底。固定报价、分阶段交付、源码与保修期一并交付。"
        />
        <meta property="og:title" content="阳仔AI · 独立开发者" />
        <meta
          property="og:description"
          content="独立开发者，为客户交付视觉动捕、智能体与量化系统。不外包、不转手、不甩锅。"
        />
      </Helmet>

      <RackNav />
      <main>
        <MorphHero />
        {channels.map((c) => (
          <ChannelSection key={c.id} channel={c} />
        ))}
        <AboutSection />
        <CollabSection />
        <ContactSection />
      </main>
      <RackFooter />
    </div>
  );
}
